import { Component, Inject, Input, OnInit, PLATFORM_ID } from '@angular/core';
import { SeoService } from 'src/app/services/seo.service';
import { TranslateModule } from '@ngx-translate/core';
import { MatFormFieldModule } from '@angular/material/form-field';
import { isPlatformBrowser, NgClass } from '@angular/common';

@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.scss'],
  standalone: true,
  imports: [MatFormFieldModule, TranslateModule, NgClass]
})
export class PrivacyComponent implements OnInit {

  @Input() modal = false;
  constructor(
    private seoService: SeoService,
    @Inject(PLATFORM_ID) private platformId: string,
  ) { }

  ngOnInit(): void {
    this.setSEOSettings();
  }

  public setSEOSettings(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.seoService.createLinkForCanonicalURL(window.location.href);
      this.seoService.updateUrl(window.location.href);
    }
  }

}
